import { TaskItem } from '../interfaces';

/**
 * This method is to fetch Launch Config of first completed Assesment or Quiz
 *  - Pass items array as items,
 *  - Pass current item index as currentItemIndex
 *  - This mehtod will return either null or launch config
 */
export const fetchLaunchConfigOfCompletedItemFromTask = (
  items: TaskItem[],
  currentItemIndex: number,
): string | undefined => {
  let counter = 0;
  let resultItem: string | undefined = undefined;
  while (counter <= currentItemIndex) {
    if (items[counter].state) {
      resultItem = items[counter].state;
      break;
    }
    counter++;
  }
  return resultItem;
};
